<template>
  <router-view />
</template>

<script setup lang="ts">
// App 入口组件
</script>

<style lang="scss">
// 全局样式已在 main.ts 中引入
</style>
